export default {
  path: '/',
  name: '',
  component: () => import(/* webpackChunkName: "home" */ './app.vue'),
  children: [
    {
      path: '',
      component: () => import(/* webpackChunkName: "home" */ './views/index.vue'),
      meta: {
        title: '首页',
      },
    },
  ],
};
